/*
* Project: xpenser-client
* FilePath: /src/app/pages/templates/index.tsx
* File: index.tsx
* Created Date: Friday, September 18th 2020, 7:35:14 pm
* Author: Craig Bojko (craig@pixelventures.co.uk)
* -----
* Last Modified: Sat Sep 19 2020
* Modified By: Craig Bojko
* -----
* Copyright (c) 2020 Pixel Ventures Ltd.
* ------------------------------------
* <<licensetext>>
*/

import React, { Suspense } from 'react'
import { IHeader } from '@common/interfaces/iHeader'
import { INavigation } from '@common/interfaces/iNavigation'

export type Layouts = 'primary' | 'blank'

export type PrimaryLayout = {
  type: Extract<Layouts, 'primary'>;
  header: React.ComponentType<IHeader>;
  navigation: React.ComponentType<INavigation>;
  content: React.ComponentType;
}
export type BlankLayout = {
  type: Extract<Layouts, 'blank'>;
  content: React.ComponentType;
}

export type Template = PrimaryLayout | BlankLayout

export const Template: React.FC<Template> = props => {
  const { type, ...components } = props
  let Layout

  // TODO - return loading boundary for suspense fallback cases
  switch (type) {
    case 'primary':
      if (!isPrimaryLayout(components)) {
        // TODO - return error boundary
        return <p>Error: Malformed layout requested</p>
      }
      Layout = React.lazy(() => import('./primary'))
      return (
        <Suspense fallback={<p>Loading layout...</p>}>
          <Layout
            Header={components.header}
            Navigation={components.navigation}
            Content={components.content}
          />
        </Suspense>
      )

    case 'blank':
    default:
      if (!isBlankLayout(components)) {
        // TODO - return error boundary
        return <p>Error: Malformed layout requested</p>
      }
      Layout = React.lazy(() => import('./blank'))
      return (
        <Suspense fallback={<p>Loading layout...</p>}>
          <Layout
            Content={components.content}
          />
        </Suspense>
      )
  }
}

function isPrimaryLayout (layout: Partial<PrimaryLayout>): layout is PrimaryLayout {
  return 'header' in layout
    && 'content' in layout
    && layout.header !== undefined
    && layout.content !== undefined
}

function isBlankLayout (layout: Partial<BlankLayout>): layout is BlankLayout {
  return 'content' in layout && layout.content !== undefined
}

export default Template
